(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
(function(){
  var KEY='paoWaBubbleClosed';
  var bubble=document.querySelector('[data-wa-bubble]');
  var closed=false;try{closed=sessionStorage.getItem(KEY)==='1';}catch(e){}
  if(bubble&&!closed&&window.matchMedia('(min-width: 761px)').matches){setTimeout(function(){bubble.hidden=false;},4000);setTimeout(function(){bubble.hidden=true;},16000);}
  document.addEventListener('click',function(event){
    var closeButton=event.target.closest('.pao-wa-close');
    if(!closeButton)return;
    var widget=closeButton.closest('.pao-wa');
    widget.querySelector('.pao-wa-icon').focus();
    widget.querySelector('.pao-wa-bubble').hidden=true;
    try{sessionStorage.setItem(KEY,'1');}catch(e){}
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pao-new-arrivals"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init = root => {
  root.querySelectorAll('[data-new-arrivals]').forEach(section => {
   if (section.dataset.ready) return;
   section.dataset.ready = 'true';
   const track = section.querySelector('[data-new-track]');
   const items = [...section.querySelectorAll('[data-new-group]')];
   const buttons = [...section.querySelectorAll('[data-new-filter]')];
   const prev = section.querySelector('[data-new-prev]');
   const next = section.querySelector('[data-new-next]');
   const update = () => { prev.disabled = track.scrollLeft < 2; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; };
   buttons.forEach(button => {
    const group = button.dataset.newFilter;
    button.hidden = group !== 'all' && !items.some(item => item.dataset.newGroup === group);
    button.addEventListener('click', () => {
     buttons.forEach(other => other.setAttribute('aria-pressed', String(other === button)));
     items.forEach(item => { item.hidden = group !== 'all' && item.dataset.newGroup !== group; });
     track.scrollLeft = 0; update();
    });
   });
   section.querySelector('.pao-new-filters').hidden = false;
   prev.hidden = false; next.hidden = false;
   const scroll = direction => track.scrollBy({left:direction * track.clientWidth, behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
   prev.addEventListener('click', () => scroll(-1)); next.addEventListener('click', () => scroll(1));
   track.addEventListener('scroll',update,{passive:true});
   new ResizeObserver(update).observe(track); update();
  });
 };
 init(document);
 document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
